import React from 'react'
// TODO move ui
// import { Message, Heading, Text } from '@brainstud/schiphol-vtc-ui'

const NoTemplate = props => (
  <div>
    <Heading h1>{props.page.title}</Heading>

    <Message>
      <Text>No template found in content/pages/{props.page.slug}/Page.js</Text>
    </Message>
  </div>
)

export default NoTemplate
